<template>
  <DialogTemplate
    :title="$t('notifications.dialog.reply')"
    @close="$emit('close')"
    @send="$emit('send', $event)"
  >
    <MessageView
      v-if="notification.parentMessageId"
      :from="getPartyTitle(notification.parentFromId, notification.parentFromEmail)"
      :title="notification.parentMessageHead"
      :text="notification.parentMessageText"
      :sent-date="notification.parentSentDatetime.toLocaleString()"
    />

    <MessageView
      :from="getPartyTitle(notification.fromId, notification.fromEmail)"
      :text="notification.messageText"
      :title="notification.messageHead"
      :sent-date="notification.sentDatetime.toLocaleString()"

    />
  </DialogTemplate>
</template>

<script>
import DialogTemplate from "./DialogTemplate";
import MessageView from "@/components/common/notifications/MessageView";

export default {
  props: {
    notification: Object,
  },
  components: {
    MessageView,
    DialogTemplate,
  },
  methods: {
    getPartyTitle(id, defaultValue = `RH# ${id}`) {
      const rh = this.$store.getters["app/rightsholder"](id);
      if (rh) {
        return rh.name;
      }
      if (id === this.$store.getters["app/adminId"]) {
        return 'Admin';
      }
      return defaultValue;
    }
  }
};
</script>
